module.exports = __webpack_public_path__ + "img/shades.95f48494.gif";